// extracted by mini-css-extract-plugin
var _1 = "VlGtL";
var _2 = "JByAs";
var _3 = "MCTJR";
var _4 = "KVFtE";
var _5 = "HqsK0";
var _6 = "ZgQW7";
var _7 = "fuffl";
export { _1 as "activeStarThemeWriteReview", _2 as "activeStarThemeYellow", _3 as "defaultStarThemeWriteReview", _4 as "defaultStarThemeYellow", _5 as "starLarge", _6 as "starMedium", _7 as "starSmall" }
